import React, { useState } from 'react'
import '../styles.css'
import sphoneme from '../assets/phonemes/s.mp3'
import mphoneme from '../assets/phonemes/m.mp3'
import tphoneme from '../assets/phonemes/t.mp3'
import pphoneme from '../assets/phonemes/p.mp3'
import nphoneme from '../assets/phonemes/n.mp3'
import cphoneme from '../assets/phonemes/c.mp3'
import kphoneme from '../assets/phonemes/k.mp3'
import rphoneme from '../assets/phonemes/r.mp3'
import bphoneme from '../assets/phonemes/b.mp3'
import jphoneme from '../assets/phonemes/j.mp3'
import fphoneme from '../assets/phonemes/f.mp3'
import gphoneme from '../assets/phonemes/g.mp3'
import hphoneme from '../assets/phonemes/h.mp3'
import dphoneme from '../assets/phonemes/d.mp3'
import wphoneme from '../assets/phonemes/w.mp3'
import vphoneme from '../assets/phonemes/v.mp3'
import lphoneme from '../assets/phonemes/l.mp3'
import yphoneme from '../assets/phonemes/y.mp3'
import AppBar from '../components/AppBar.js'
import LetterAnswerButton from '../components/answers/Letter/LetterAnswerButton.js'
import OnlyAudioQuestion from '../components/questions/OnlyAudioQuestion.js'
import GameResults from './GameResults.js'
import LevelFeedback from '../components/levelDesign/LevelFeedback.js'
import LetterIntroduction from '../components/levelDesign/LetterIntroduction.js'
import Tutorial from '../components/levelDesign/Tutorial.js'
import first from '../assets/howTo/first.m4a'
import second from '../assets/howTo/second.m4a'
import third from '../assets/howTo/third.m4a'
import fourth from '../assets/howTo/fourth.m4a'
import fifth from '../assets/howTo/fifth.m4a'

export const letters = [
    ['s', 'm', 't'],
    ['p', 'n', 'c'],
    ['k', 'r', 'b'],
    ['j', 'f', 'g'],
    ['h', 'd', 'w'],
    ['v', 'l', 'y']
];
const sounds = {
    's': sphoneme,
    'm': mphoneme,
    't': tphoneme,
    'p': pphoneme,
    'n': nphoneme,
    'c': cphoneme,
    'k': kphoneme,
    'r': rphoneme,
    'b': bphoneme,
    'j': jphoneme,
    'f': fphoneme,
    'g': gphoneme,
    'h': hphoneme,
    'd': dphoneme,
    'w': wphoneme,
    'v': vphoneme,
    'l': lphoneme,
    'y': yphoneme
}

const howToPlayAudioFiles = {
    1: first,
    2: second,
    3: third,
    4: fourth,
    5: fifth
}

var questions = [[0, 3], [1, 3], [2, 3]]
var levelResponses = [];
var randomSelection = Math.floor(Math.random() * questions.length);
var questionLetter = questions[randomSelection][0];
var questionType = questions[randomSelection][1];
var questionNumber = 0;
var audioCheck = 1;
var maxQuestionNumber = 3;
var tutorialAudio = new Audio()

function LevelPage4(props) {
    const [buttonSelectedID, setSelectedButtonID] = useState(0);
    const [responses, setResponses] = useState([]);
    const [submitState, setSubmitState] = useState(0);
    const [typeLetter, setTypeLetter] = useState('');
    const [dialogue, setDialogue] = useState('correct')
    const [skip, setSkip] = useState(0)
    const audio = new Audio(sounds[letters[props.level - 1][questionLetter]])
    tutorialAudio.pause()
    var submitText = 'Submit'

    if (submitState === 0) {
        submitText = 'Submit'
    } else if (submitState === 1) {
        submitText = 'Next'
    }

    if (questionNumber == 0) {
        switch (skip) {
            case 0:
                tutorialAudio = new Audio(howToPlayAudioFiles[3])
                tutorialAudio.play()
                return (
                    <div>
                        <AppBar backTo='Level Select' displayText='Level Select' name={`Introduction - ${letters[props.level - 1].toString().toUpperCase()}`} />
                        <div className='column' style={{marginTop: 80}}>
                            <Tutorial levelType={3} />
                            <div className='submitArea' style={{marginTop: 50}}>
                                <button className='skipButton' onClick={() => skipThrough()}>Skip</button>
                            </div>
                        </div>
                    </div>
                )
            case 1:
                return (
                    <div>
                        <AppBar backTo='Level Select' displayText='Level Select' name={`Introduction - ${letters[props.level - 1].toString().toUpperCase()}`} />
                        <div className='column' style={{marginTop: 80}}>
                            <LetterIntroduction letter={letters[props.level - 1][0]}/>
                            <LetterIntroduction letter={letters[props.level - 1][1]}/>
                            <LetterIntroduction letter={letters[props.level - 1][2]}/>
                            <div className='submitArea' style={{marginTop: 50}}>
                                <button className='skipButton' onClick={() => skipThrough()}>Skip</button>
                            </div>
                        </div>
                    </div>
                )
            default:
        }
    } else {
        switch (questionType) {
            case 3:
                if (audioCheck === 1) {
                    audio.play()
                    audioCheck = 0;
                }
                return (
                    <div>
                        <AppBar name={`${letters[props.level - 1].toString().toUpperCase()} - Question ${questionNumber}/${maxQuestionNumber}`} />
                        <OnlyAudioQuestion letter={letters[props.level - 1][questionLetter]} resetVariables={() => resetVariables()} />
                        <div className='answer'>
                            <div className='answerRow'>
                                <LetterAnswerButton id={1} letter={letters[props.level - 1][0]} correctLetter={questionLetter} currentlyClicked={buttonSelectedID} stateChanger={setSelectedButtonID} submitState={submitState} setIncorrectDialogue={setIncorrectDialogue} setCorrectDialogue={setCorrectDialogue} />
                                <LetterAnswerButton id={2} letter={letters[props.level - 1][1]} correctLetter={questionLetter} currentlyClicked={buttonSelectedID} stateChanger={setSelectedButtonID} submitState={submitState} setIncorrectDialogue={setIncorrectDialogue} setCorrectDialogue={setCorrectDialogue} />
                                <LetterAnswerButton id={3} letter={letters[props.level - 1][2]} correctLetter={questionLetter} currentlyClicked={buttonSelectedID} stateChanger={setSelectedButtonID} submitState={submitState} setIncorrectDialogue={setIncorrectDialogue} setCorrectDialogue={setCorrectDialogue} />
                            </div>
                        </div>
                        <div className='submitArea'>
                            <button className='signupFormSubmitButton' onClick={() => handleSubmit()}>{submitText}</button>
                        </div>
                        <LevelFeedback submitState={submitState} dialogue={dialogue} letter={letters[props.level - 1][questionLetter]}/>
                    </div>
                );
            case 6:
                questions = [[0, 3], [1, 3], [2, 3]]
                randomSelection = Math.floor(Math.random() * questions.length);
                questionLetter = questions[randomSelection][0];
                questionType = questions[randomSelection][1];
                questionNumber = 0;
                levelResponses = [];
                return <GameResults identification={props.identification} letters={letters[props.level - 1]} responses={responses} level={props.level} />
            default:
        }
    }

    function handleSubmit() {
        if (buttonSelectedID === 0 && questionType !== 4) {

        } else {
            if (submitState === 0) {
                if (questionType === 4) {
                    if (letters[props.level - 1][questionLetter] === typeLetter) {
                        levelResponses.push([`${letters[props.level - 1][questionLetter]}`, 'correct'])
                    } else {
                        levelResponses.push([`${letters[props.level - 1][questionLetter]}`, 'incorrect'])
                    }
                } else {
                    if ((questionLetter + 1) === buttonSelectedID) {
                        levelResponses.push([`${letters[props.level - 1][questionLetter]}`, 'correct'])
                    } else {
                        levelResponses.push([`${letters[props.level - 1][questionLetter]}`, 'incorrect'])
                    }
                }
                setSubmitState(1)
            } else if (submitState === 1) {
                questions.splice(randomSelection, 1)
                if (questions.length === 0) {
                    questionType = 6;
                    setSelectedButtonID(0)
                    setTypeLetter('')
                    questionNumber += 1;
                    audioCheck = 1;
                } else {
                    setSelectedButtonID(0)
                    setResponses(levelResponses)
                    setTypeLetter('')
                    randomSelection = Math.floor(Math.random() * questions.length);
                    questionLetter = questions[randomSelection][0];
                    questionType = questions[randomSelection][1];
                    questionNumber += 1;
                    audioCheck = 1;
                }
                setSubmitState(0)
            }
        }
    }

    function resetVariables() {
        levelResponses = []
        questions = [[0, 3], [1, 3], [2, 3]]
        questionNumber = 0;
        audioCheck = 1;
    }

    function setIncorrectDialogue() {
        setDialogue('incorrect')
    }

    function setCorrectDialogue() {
        setDialogue('correct')
    }

    function skipThrough() {
        if (skip == 1) {
            questionNumber += 1
            setSkip(0)
        } else {
            setSkip(skip+1)
        }
    }

}

export default LevelPage4;